/**
 * Implementa o modelo de uma tabela do IndexedDataBase.
 */
export default class IndexedDataBaseTable {
    #defaultName = "";
    #defaultOptions = {
        autoIncrement: true, 
        keyPath: 'id'
    };
    /**
     * 
     * @param {String} name nome da tabela a ser implementado; 
     * @param {Object} options Opções da tabela a serem implementadas;
     * @param {Boolean} options.autoIncrement Boleano que define se o identificador
     * se auto incrementa;
     * @param {String} options.keyPath Define qual o caminho no objeto para a chave;
     */
    constructor(name = this.#defaultName, options = {}) {
        this.name = name,
        this.options = {
            ...this.#defaultOptions,
            ...options
        }
    }
}
